module.exports = __webpack_public_path__ + "img/de.a9fc0bda.svg";